export default {
	common: {
		noMore: '더 이상 없습니다',
		noEmpty: '반드시 업로드',
		copySuccess: '복사 성공',
		copyFail: '복사 실패',
		paySuccess: '결제 성공',
		payFail: '결제 실패',
		search: '검색',
		remark: '비고',
		commit: '제출',
		status: '상태',
		revoke: '취소',
		cancel: '취소',
		confirm: '확인',
		close: '닫기',
		getbtn: '수령',
		selectTime: '시간 선택',
		selectDate: '날짜 선택',
		uploadImage: '사진 업로드',
		uploadVideo: '동영상 업로드',
		activity: '이벤트',
		problem: '문제',
		money: '금액',
		reply: '답변',
		other: '기타',
		send: '발송',
		copy: '복사',
		view: '보기',
		next: '다음',
		feedback: '피드백 할래',
		enter: '입력하세요',
		loading: '로딩 중...',
		rotateTips: '더욱 좋은 체험하실려면 휴대폰을 회전해주십시오',
		purchase: '충전',
		purchased: '구매 완료',
		getBtn: '수령',
		onekeyGetBtn: '일괄수령',
		freeGetBtn: '무료 수렴',
		countdown: '이벤트 종료',
		days: '일',
		hour: '시',
		minute: '분',
		second: '초',
		ruleDefault: '无',//없음
		emptyDefault: '이곳에 아무것도 없습니당~',
		monetaryUnit: '원',
		mUnit: '₩',
		ruleTitle: '규칙 설명',
		tipsTitle: '알림',
		repeatTips: '자주 조작하지 마십시오',
		thousand: '천',
		tenThousand: '만',
		tenMillion: '천만',
		billion: '억',
		hundredBillion: '천억',
		trillions: '만억',
		quadrillions: '천만억',
		noOpen: '잠시 미오픈'
	},
	menu: {
		home: 'HOME',
		about: 'ABOUT US',
		contact: 'CONTACT',
		clauseService: 'Privacy',
		clauseUser: 'Agreement'
	},
	footer: {
		company: 'zijinggames',//'HONG KONG BUFF TECHNOLOGY CO., LIMITED',
		email: "hongkongbufftechnologycolimite{'@'}gmail.com",
		tel: '+852 5285 9266',
		addr: ''//'RM 517 NEW CITY CTR 2 LEI YUEMUN RD KWUN TONGHONG KONG'
	},
	upload: {
		label: '업로드',
		loading: '업로드 중...',
		success: '업로드 성공',
		fail: '업로드 실패',
		sizeTips: '파일 크기는 {size} M 초과할 수 없습니다',
	}
}